export const OrderStatusMap = {
    1: "New Order",
    2: "Accepted",
    3: "Active",
    4: "Failed",
    5: "Confirmed",
    6: "Pending",
    7: "Rejected",
    8: "Picked Up",
    9: "Delivered", 
    10: "Processing",
  };

  export const TransactionStatus = {
    1 : "Pending",
    2 : "Initiated",
    3 : "Success",
    4 : "Failed"
  }

 export const CompliantStatusEnum = {
    1: "Open",
    2: "In Progress",
    3: "Resolved", 
  }

  export const  NotificationType = {
    1: "New Order",
    2: "Order Sent",
    3: "Order Picked",
    4: "Order Delivered",
    5: "Received Payment",
    6: "Initialized Payment",
    7: "Assign Agent",
    8: "Change OrderStatus"
  }
    